import { render } from "./SingleJob.vue?vue&type=template&id=0a17c72c&scoped=true"
import script from "./SingleJob.vue?vue&type=script&lang=js"
export * from "./SingleJob.vue?vue&type=script&lang=js"

import "./SingleJob.vue?vue&type=style&index=0&id=0a17c72c&lang=scss&scoped=true"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a17c72c"]])

export default __exports__